<template>
  <v-dialog v-model="dialog" max-width="750" scrollable>
    <v-card>
      <v-card-title class="font-weight-bold"
        >Capacidades Caixa {{ caixaSelec }}</v-card-title
      >
      <v-card-subtitle
        >Produtos disponíveis para esta caixa

        <v-text-field
          v-model="pesquisa"
          label="Pesquisar"
          hide-details=""
        ></v-text-field>
      </v-card-subtitle>
      <v-card-text>
        <v-data-table
          :items="capac_veiculo"
          :headers="headers"
          :search="pesquisa"
          no-data-text="Nenhum produto encontrado"
          no-results-text="Nenhum produto localizado com este filtro"
          dense
          :header-props="{ sortByText: 'Ordenar por' }"
          sort-by="produto"
        >
          <template v-slot:[`item.codgpsgit`]="{ item }">
            {{ item.gp }}-{{ item.sgp }}-{{ item.item }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          @click="dialog = false"
          text
          block
          :class="{ secondary: isMobile() }"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      }
    },
  },
  computed: {
    ...mapState("formacaoCarga", ["caixaSelec", "veiculo"]),
  },
  data: () => ({
    pesquisa: "",
    dialog: false,
    capac_veiculo: [],
    headers: [
      { text: "Cód", value: "codgpsgit" },
      /*{ text: "Gp", value: "gp" },
      { text: "Sgp", value: "sgp" },
      { text: "Item", value: "it" },*/
      { text: "Produto", value: "produto" },
      { text: "Emb", value: "embalagem" },
      { text: "Capacidade(Kgs)", value: "capacidade" },
    ],
  }),
  methods: {
    ...mapMutations("formacaoCarga", ["setCaixa"]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.setCaixa(this.$route.params.cx);
    this.capac_veiculo = this.veiculo.dados.caixas.find(
      (cx) => cx.caixa == this.caixaSelec
    ).capacidade;
    this.dialog = true;
  },
};
</script>

<style>
.btn-capac {
  position: absolute;
  bottom: -26px;
}

.nro-ped-cx {
  position: absolute;
  top: -65px;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  color: black;  
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 12px;
  white-space: nowrap;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);
}

.nro-ped-cx::after {
  content: "";
  position: absolute;
  top: 100%; /* Posiciona abaixo do balão */
  left: 50%;
  transform: translateX(-50%);
  border-width: 8px;
  border-style: solid;
  border-color: white  transparent transparent transparent;
}

@media only screen and (max-width: 750px) {
  .btn-capac {
    position: absolute;
    right: -4px;
    top: -12px;
  }
}
</style>